module.exports = __webpack_public_path__ + "img/collection-weddingRingsForestGreen@2x.7e55928.jpg";